import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import client from "./client";
import API_ENDPOINTS from "../constants/api-endpoints";

type CB = { onSuccess?: (r: any) => void; onError?: (e: any) => void };

export const useIntegrations = (cid: number) =>
  useQuery({
    queryKey: ["integrations", cid],
    queryFn: () => client.get(API_ENDPOINTS.INT_LIST(cid)).then((r) => r.data.data as any[]),
    enabled: !!cid,
    refetchOnWindowFocus: false,
  });

export const useIntegrationUpsert = ({ onSuccess, onError }: CB = {}) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ cid, data }: { cid: number; data: any }) =>
      client.post(API_ENDPOINTS.INT_UPSERT(cid), data),
    onSuccess: (r, v) => { qc.invalidateQueries({ queryKey: ["integrations", v.cid] }); onSuccess?.(r); },
    onError: (e) => onError?.(e),
  });
};

export const useIntegrationDisconnect = ({ onSuccess, onError }: CB = {}) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ cid, id }: { cid: number; id: number }) =>
      client.patch(API_ENDPOINTS.INT_DISCONNECT(cid, id)),
    onSuccess: (r, v) => { qc.invalidateQueries({ queryKey: ["integrations", v.cid] }); onSuccess?.(r); },
    onError: (e) => onError?.(e),
  });
};

export const useIntegrationDelete = ({ onSuccess, onError }: CB = {}) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ cid, id }: { cid: number; id: number }) =>
      client.delete(API_ENDPOINTS.INT_DELETE(cid, id)),
    onSuccess: (r, v) => { qc.invalidateQueries({ queryKey: ["integrations", v.cid] }); onSuccess?.(r); },
    onError: (e) => onError?.(e),
  });
};
